import * as React from 'react';
import * as FocusTrap from "focus-trap-react";
import {observer} from "mobx-react";
import {action} from "mobx";
import './CheckInConfetti.pcss';
import {
  CHECK_IN_RESPONSE_SOLUTION_NOT_OPEN,
  CHECK_IN_RESPONSE_STATUS_ALREADY_CHECKED_IN,
  CHECK_IN_RESPONSE_STATUS_NOT_FOUND, CHECK_IN_RESPONSE_STATUS_PASSCODE_INCORRECT,
  CHECK_IN_RESPONSE_STATUS_SUCCESS, CHECK_IN_RESPONSE_STATUS_UNKNOWN_FAILURE, CHECK_IN_RESPONSE_STATUS_PASSCODE_EMPTY,
  solutionDataSource
} from "../../../data/SolutionDataSource";
import {UIState} from "data/UIState";

interface Props {
}

/**
 * This class pops open after an attempt to check-in
 * to an on-site solution
 *
 */
@observer
export class CheckInConfetti extends React.Component<Props> {

  @action clear = () => {
    solutionDataSource.hideCheckInConfetti();
    UIState.setAriaLiveAnnouncement("New content has been unlocked and is visible on this page.");
  }

  render() {

    if(!solutionDataSource.checkInResponse) {
      return null;
    }




    return (

        <div className={"badge-achieved-modal"}>
          <FocusTrap focusTrapOptions={
            {
              allowOutsideClick: false,
              clickOutsideDeactivates: true,
              onDeactivate:()=>{
                this.clear();
              },
            }
          }>
            <div role="dialog" aria-modal={true} onClick={(e)=>{ e.stopPropagation(); }}>

              {CHECK_IN_RESPONSE_STATUS_SUCCESS===solutionDataSource.checkInResponse.statusCode && solutionDataSource.checkInResponse.solutionBundle && <>
                <h2 className={'level2'}>Check-in Complete!</h2>
                <p>
                  You have successfully checked in to {solutionDataSource.checkInResponse.solutionBundle.bundleName}{solutionDataSource.checkInResponse.solutionBundle.checkInPointValue
                  ?
                    ', and have earned '+solutionDataSource.checkInResponse.solutionBundle.checkInPointValue+' point'+(solutionDataSource.checkInResponse.solutionBundle.checkInPointValue>1?'s':'')+'!'
                  :
                    '!'
                  }
                </p>
              </>}

              {CHECK_IN_RESPONSE_STATUS_ALREADY_CHECKED_IN===solutionDataSource.checkInResponse.statusCode && solutionDataSource.checkInResponse.solutionBundle && <>
                <h2>Already Checked-In</h2>
                <p>
                  You already successfully checked in to {solutionDataSource.checkInResponse.solutionBundle.bundleName}{solutionDataSource.checkInResponse.solutionBundle.checkInPointValue
                    ?
                    ', and earned '+solutionDataSource.checkInResponse.solutionBundle.checkInPointValue+' point'+(solutionDataSource.checkInResponse.solutionBundle.checkInPointValue>1?'s':'')+'.'
                    :
                    '.'
                }
                </p>
              </>}

              {CHECK_IN_RESPONSE_STATUS_PASSCODE_EMPTY===solutionDataSource.checkInResponse.statusCode && <>
                <h2>Codeword Required</h2>
                <p>Please enter the codeword before hitting Check-In.</p>
              </>}

              {CHECK_IN_RESPONSE_SOLUTION_NOT_OPEN===solutionDataSource.checkInResponse.statusCode && <>
                <h2>Not Open</h2>
                <p>{solutionDataSource.checkInResponse.solutionName} is not open, and therefore you cannot check in to any booths.</p>
              </>}

              {CHECK_IN_RESPONSE_STATUS_PASSCODE_INCORRECT===solutionDataSource.checkInResponse.statusCode && <>
                <h2>Codeword Incorrect</h2>
                <p>The codeword that you entered is not correct.</p>
              </>}

              {CHECK_IN_RESPONSE_STATUS_NOT_FOUND===solutionDataSource.checkInResponse.statusCode && <>
                <h2>Booth not found!</h2>
                <p>The QR Code that you scanned did not correspond to an active on-site booth or solution.</p>
              </>}

              {CHECK_IN_RESPONSE_STATUS_UNKNOWN_FAILURE===solutionDataSource.checkInResponse.statusCode && <>
                <h2>Unexpected Failure!</h2>
                <p>The QR Code that you scanned or codeword that you entered resulted in a failed attempt to check-in to an on site booth. It is possible that
                  you may have lost your Internet connection briefly. Please try again.</p>
              </>}

              <button className={'three-band-focus'} onClick={this.clear}>Ok</button>
            </div>
          </FocusTrap>
        </div>

    );
  }
}

